import dateTimeHelper from './datetimeHelper';
import stringHelper from './stringHelper';

const MonthsBack = 12;
const MonthsAhead = 6;

// The months an automatic invoicing setup can start from: a year back to half a year ahead of today's month, widened
// to take in the stored month when it lies outside. Values are the 1st of the month as yyyy-MM-dd, as the backend
// sends and reads them; labels read "October 2026".
export function getFirstMonthOptions(today: Date, storedFirstMonth?: string | null) {
  const currentMonthNumber = today.getFullYear() * 12 + today.getMonth();
  let firstMonthNumber = currentMonthNumber - MonthsBack;
  let lastMonthNumber = currentMonthNumber + MonthsAhead;
  const storedMonthNumber = getMonthNumber(storedFirstMonth);
  if (storedMonthNumber !== null) {
    firstMonthNumber = Math.min(firstMonthNumber, storedMonthNumber);
    lastMonthNumber = Math.max(lastMonthNumber, storedMonthNumber);
  }

  const options = [];
  for (let monthNumber = firstMonthNumber; monthNumber <= lastMonthNumber; monthNumber++) {
    const year = Math.floor(monthNumber / 12);
    const month = monthNumber % 12;
    options.push({
      label: getMonthLabel(monthNumber),
      value: `${year}-${stringHelper.addLeadingZero(month + 1)}-01`,
    });
  }
  return options;
}

// "September 2026" for a yyyy-MM-dd text; the text itself when it holds no readable month.
export function formatMonthLabel(isoDate?: string | null) {
  const monthNumber = getMonthNumber(isoDate);
  if (monthNumber === null) {
    return isoDate ?? '';
  }
  return getMonthLabel(monthNumber);
}

function getMonthLabel(monthNumber: number) {
  const year = Math.floor(monthNumber / 12);
  const month = monthNumber % 12;
  return `${dateTimeHelper.MonthName(month)} ${year}`;
}

// Years times twelve plus the zero-based month of a yyyy-MM-dd text; null when there is no readable month.
function getMonthNumber(isoDate?: string | null) {
  const parts = (isoDate ?? '').split('-');
  const year = Number(parts[0]);
  const month = Number(parts[1]);
  if (parts.length < 2 || !Number.isInteger(year) || !Number.isInteger(month) || month < 1 || month > 12) {
    return null;
  }
  return year * 12 + month - 1;
}
